<div class="animated fadeInBottom">
    <mat-tab-group [className]="'mat-tab-group status-tabs'"
                   [(selectedIndex)]="currentIndex"
                   (selectedTabChange)="changeActiveTab($event)">
        <mat-tab *ngFor="let tab of tabs; let i=index"
                 [bodyClass]="['d-none']">
            <ng-template matTabLabel>
                <ng-template #defaultTab>
                    <span class="lead">{{tab.count}}</span>
                    <small class="d-block text-left text-ellipsis text-nowrap overflow-hidden py-2 w-100">{{tab.name}}</small>
                </ng-template>
                <ng-container *ngIf="tab.color; else defaultTab">
                    <span class="lead"
                          [adjustColor]="currentIndex === i ? tab.color : defaultTabColor"
                          [attribute]="'color'"
                          [adjustment]="adjustColorValues.TEXT">{{tab.count}}</span>
                    <small class="d-block text-left text-ellipsis text-nowrap overflow-hidden py-2 w-100"
                           [adjustColor]="currentIndex === i ? tab.color : defaultTabColor"
                           [attribute]="'color'"
                           [adjustment]="adjustColorValues.TEXT">{{tab.name}}</small>
                </ng-container>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>
